// src/app/services/meta-pixel.service.ts
import { Injectable } from '@angular/core';
import { runOnFirstInteraction } from 'projects/shared/utils/defer-until-interaction';

declare let fbq: Function;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  initialize(pixelId: string): void {
    this.loadScript(pixelId);
  }

  private loadScript(pixelId: string): void {
    if (typeof window === 'undefined') return; // SSR Guard

    // The fbq stub is created straight away and queues every call, so events fired before
    // fbevents.js arrives are not lost. Only the network request is deferred.
    const metaPixelScript = document.createElement('script');
    metaPixelScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];n.load=function(){t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(metaPixelScript);

    runOnFirstInteraction(() => {
      (window as any).fbq?.load?.();

      const clarityScript = document.createElement('script');
      clarityScript.type = 'text/javascript';
      clarityScript.innerHTML = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "wq8023ugrr");
      `;
      document.head.appendChild(clarityScript);
    });
  }
}
